// src/components/TopNavbar.jsx
import React from "react";
import { Coins, Puzzle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useUser } from "./UserContext";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";

const TopNavbar = ({ onSignUpClick, onLoginClick }) => {
  const navigate = useNavigate();
  const { user, setUser } = useUser();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUser(null);
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <div className="backdrop-blur-md bg-gradient-to-br from-gray-900 to-gray-800 text-white px-4 py-3 flex justify-between items-center sm:px-6">
      {/* Left: Volver + Título */}
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate(-1)}
          className="font-semibold hover:underline text-sm sm:text-base"
        >
          &larr; Back
        </button>
        <span className="font-semibold hidden sm:inline"></span>
      </div>

      {/* Right: Botones y Avatar */}
      <div className="flex items-center gap-2 sm:gap-4 overflow-x-auto">
        {!user ? (
          <>
            <button
              className="bg-white text-black rounded-full px-3 py-1 text-xs sm:text-sm font-semibold shadow"
              onClick={onSignUpClick}
            >
              Sign Up
            </button>
            <button
              className="bg-white text-black rounded-full px-3 py-1 text-xs sm:text-sm font-semibold shadow"
              onClick={onLoginClick}
            >
              Login
            </button>
          </>
        ) : (
          <button
            className="bg-red-500 text-white rounded-full px-3 py-1 text-xs sm:text-sm font-semibold shadow hover:bg-red-600 transition"
            onClick={handleLogout}
          >
            Logout
          </button>
        )}

        <div className="flex items-center gap-1 sm:gap-2 bg-orange-400 text-white rounded-full px-3 py-1 text-xs sm:text-sm font-semibold">
          <Coins size={14} />
          0
        </div>

        <div className="flex items-center gap-1 sm:gap-2 bg-yellow-400 text-white rounded-full px-3 py-1 text-xs sm:text-sm font-semibold">
          <Puzzle size={14} />
          0
        </div>

        <img
          src="/avatar.png"
          alt="Avatar"
          className="w-7 h-7 sm:w-8 sm:h-8 rounded-full"
        />
      </div>
    </div>
  );
};

export default TopNavbar;
